import initialState from "./initialState";

export function FlightNoRangeReducer(state = initialState.flightNoRangeFormValues, action) {
  switch (action.type) {
    case "FLIGHT_NO_RANGE_FORM_DATA_REQUEST":
      return {
        ...state,
        flightNoRangeFormValues: action.payload,
      };
    default:
      return state;
  }
}
